module.exports = __webpack_public_path__ + "img/icon-checkbox-tree.aedc1a06.svg";